module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vsm-item",
    class: [{
      'first-item': _vm.firstItem
    }, {
      'open-item': _vm.show
    }, {
      'active-item': _vm.active
    }, {
      'parent-active-item': _vm.childActive
    }],
    on: {
      "mouseenter": function($event) {
        return _vm.mouseEnter($event)
      }
    }
  }, [(!_vm.item.child) ? [(_vm.isRouterLink) ? [_c('router-link', {
    staticClass: "vsm-link",
    attrs: {
      "to": {
        name: _vm.item.href
      },
      "disabled": _vm.item.disabled,
      "event": _vm.item.disabled ? '' : 'click'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clickEvent.apply(null, arguments)
      }
    }
  }, [(_vm.item.icon) ? _c('i', {
    staticClass: "vsm-icon",
    class: _vm.item.icon
  }) : _vm._e(), _vm._v(" "), (!_vm.isCollapsed) ? _c('span', {
    staticClass: "vsm-title"
  }, [_vm._v(_vm._s(_vm.item.title))]) : _vm._e()])] : [_c('a', {
    staticClass: "vsm-link",
    attrs: {
      "href": _vm.item.href,
      "disabled": _vm.item.disabled
    },
    on: {
      "click": _vm.clickEvent
    }
  }, [(_vm.item.icon) ? _c('i', {
    staticClass: "vsm-icon",
    class: _vm.item.icon
  }) : _vm._e(), _vm._v(" "), (!_vm.isCollapsed) ? _c('span', {
    staticClass: "vsm-title"
  }, [_vm._v(_vm._s(_vm.item.title))]) : _vm._e()])]] : [_c('a', {
    staticClass: "vsm-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleDropdown.apply(null, arguments)
      }
    }
  }, [(_vm.item.icon) ? _c('i', {
    staticClass: "vsm-icon",
    class: _vm.item.icon
  }) : _vm._e(), _vm._v(" "), (!_vm.isCollapsed) ? [_c('span', {
    staticClass: "vsm-title"
  }, [_vm._v(_vm._s(_vm.item.title))]), _vm._v(" "), _c('i', {
    staticClass: "vsm-arrow",
    class: {
      'open-arrow': _vm.show
    }
  })] : _vm._e()], 2), _vm._v(" "), (!_vm.isCollapsed) ? _c('div', {
    staticClass: "vsm-dropdown"
  }, [_c('transition', {
    attrs: {
      "name": "show-animation"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "vsm-list"
  }, _vm._l((_vm.item.child), function(subItem, index) {
    return _c('sub-item', {
      key: index,
      attrs: {
        "item": subItem
      }
    })
  }), 1) : _vm._e()])], 1) : _vm._e()]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04fe8b44","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/Item.vue
// module id = Z0Y2
// module chunks = 36